import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { FaArrowLeft } from 'react-icons/fa';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { checkLoggedIn, consultantLogin, doctorLogin, mainDoctorLogin, receptionistLogin, assistantDoctorLogin, adminLogin } from '../Redux/AuthReducer/action';
import axios from 'axios';
import { END_POINT, setClinicProfile } from '../Redux/AdminReducer/action';
import BrandLogo from '../Components/CommonComponents/BrandLogo';

const fetchItemSingle = async (path) => {
  try {
    const result = await axios.get(`${END_POINT}/${path}`);
    return result;
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    console.log(error);
  }
};

export default function Login() {
  const userLoginFail = useSelector((state) => state.AuthReducer.userLoginFail);
  const userLoginSuccess = useSelector((state) => state.AuthReducer.userLoginSuccess);
  const userLoginProcess = useSelector((state) => state.AuthReducer.userLoginProcess);
  const [userInput, setUserInput] = useState({ email: '', password: '' });
  const [userName, setUserName] = useState({ name: '', role: '' });
  const [forgotpassword, setisforgotpassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [isSendingResetLink, setIsSendingResetLink] = useState(false);
  const clinicProfile = useSelector(state=>state?.AdminReducer.clinicProfile)


  useEffect(()=>{
    dispatch(setClinicProfile())
  }, [0])

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // handel custom input change
  const handelCustomInputChange = (e) => {
    setUserInput({ ...userInput, [e.target.name]: e.target.value });
  };

  const handelCustomButtonClick = async () => {
    let userEmail = await fetchItemSingle(`configAccess/public/users/getUsersDetails?username=${userName?.name}`);
    let role = userEmail?.data?.role

    const data = {
      email: userEmail?.data?.email?.trim(),
      password: userInput.password.trim(),
    };

    if (!data.email || !data.password) {
      return toast.error('Please fill all required fields.', { position: toast.POSITION.TOP_RIGHT });
    }

    if (!/\S+@\S+\.\S+/.test(data.email)) {
      toast.error('Invalid email.', { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    if (role === 'MainDoctor') {
      dispatch(mainDoctorLogin(data));
    } else if (role === 'Receptionist') {
      dispatch(receptionistLogin(data));
    } else if (role === 'Consultant') {
      dispatch(consultantLogin(data));
    } else if (role === 'Doctor') {
      dispatch(doctorLogin(data));
    } else if (role === 'AssistantDoctor') {
      dispatch(assistantDoctorLogin(data));
    } else if (role === 'Admin') {
      dispatch(adminLogin(data));
    }
    
  };

  const handleSendResetLink = async () => {
    const email = userInput.email.trim();

    if (!email) {
      return toast.error('Please enter your email address.', { position: toast.POSITION.TOP_RIGHT });
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      return toast.error('Invalid email.', { position: toast.POSITION.TOP_RIGHT });
    }

    setIsSendingResetLink(true);
    try {
      const result = await axios.post(`${END_POINT}/resetPassword/public/forgotPassword`, {
        email,
        origin: window.location.origin,
      });
      toast.success(result?.data?.msg || 'If that email is registered, a reset link has been sent to it.');
      setUserInput((prev) => ({ ...prev, email: '' }));
    } catch (error) {
      toast.error(error?.response?.data || 'Could not send the reset link. Please try again.');
    } finally {
      setIsSendingResetLink(false);
    }
  };

  useEffect(() => {
    if (!userLoginProcess && userLoginSuccess) {
      ['/', '/login']?.includes(window.location.pathname) && navigate('/dashboard');
    }
  }, [userLoginProcess, userLoginSuccess, userLoginFail, navigate]);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      {forgotpassword ? (
        <div className="bg-white rounded-2xl shadow-lg w-full max-w-md overflow-hidden">
          {/* Back Button */}
          <button 
            onClick={() => setisforgotpassword(false)}
            className="p-4 text-gray-600 hover:text-gray-800 transition-colors"
          >
            <FaArrowLeft className="w-5 h-5" />
          </button>
          
          <div className="px-10 pb-10">
            <h1 className="text-2xl font-serif font-bold text-center text-gray-800 mb-8">Reset Password</h1>
            
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Enter Your Email
              </label>
              <input
                id="email"
                type="email"
                name="email"
                value={userInput.email}
                onChange={handelCustomInputChange}
                placeholder="Enter your email address"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition"
                required
              />

              <button
                type="button"
                onClick={handleSendResetLink}
                disabled={isSendingResetLink}
                className="w-full bg-teal-600 hover:bg-teal-700 text-white py-3 px-4 rounded-lg font-medium mt-6 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {isSendingResetLink ? 'Sending…' : 'Send Reset Link'}
              </button>
              <div className="text-center mt-6">
                <button
                  type="button"
                  onClick={() => setisforgotpassword(false)}
                  className="text-sm text-teal-600 hover:text-teal-700 font-medium"
                >
                  Back to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-white rounded-2xl shadow-lg w-full max-w-md overflow-hidden">
          {/* Back Button */}
          <button 
            onClick={() => window.history.back()}
            className="p-4 text-gray-600 hover:text-gray-800 transition-colors"
          >
            <FaArrowLeft className="w-5 h-5" />
          </button>
          
          <div className="px-10 pb-10">
            {/* Header */}
            <div className="flex flex-col items-center mb-8">
              <BrandLogo
                alt="logo"
                className="mx-auto"
                style={{ width: '150px', height: '70px', paddingBottom: '12px', objectFit: 'contain' }} 
              />
              <h1 className="text-2xl font-serif font-bold text-gray-800 mb-2">Login</h1>
            </div>

            {/* Login Form */}
            <form onSubmit={(e) => { e.preventDefault(); handelCustomButtonClick(); }}>
              {/* Email Field */}
              <div className="mb-4">
                <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
                  Email Address <span className="text-red-500">*</span>
                </label>
                <input
                  id="username"
                  type="email"
                  value={userName?.name}
                  onChange={(e) => setUserName({ name: e.target.value })}
                  placeholder="Enter your email address"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition"
                  required
                />
              </div>

              {/* Password Field */}
              <div className="mb-1">
                <div className="flex justify-between items-center mb-1">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                    Password <span className="text-red-500">*</span>
                  </label>
                </div>
                <div className="relative">
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={userInput.password}
                    onChange={handelCustomInputChange}
                    placeholder="Enter your password"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-blue-50 focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition"
                    required
                  />
                  <button
                    type="button"
                    onClick={handlePasswordVisibility}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                  >
                    {showPassword ? (
                      <AiFillEyeInvisible className="h-5 w-5" />
                    ) : (
                      <AiFillEye className="h-5 w-5" />
                    )}
                  </button>
                </div>
              </div>

              {/* Forgot Password Link */}
              <div className="text-right mb-6">
                <button
                  type="button"
                  onClick={() => setisforgotpassword(true)}
                  className="text-sm text-teal-600 hover:text-teal-700 font-medium"
                >
                  Forgot Password?
                </button>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                className="w-full bg-teal-600 hover:bg-teal-700 text-white py-3 px-4 rounded-lg font-medium transition-colors"
              >
                LOGIN
              </button>

              {/* Register Link */}
              <div className="text-center mt-6 text-sm text-gray-600">
                Don't have an account?{' '}
                  <a
    href="https://shivenclinic.com/application/subscribe"
    className="text-teal-600 hover:text-teal-700 font-medium"
  >
    Register here
  </a>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* <ToastContainer /> */}
    </div>
  );
}
